import type { PixelEvent } from '@/events';

import { shouldTripCircuitBreaker } from '../errors';
import type { EventSender, SendOptions, SendResult } from '../sender/types';
import type { CircuitBreaker } from './CircuitBreaker';

export class CircuitBreakerSender implements EventSender {
  private readonly circuitBreaker: CircuitBreaker;

  private readonly inner: EventSender;

  constructor(circuitBreaker: CircuitBreaker, inner: EventSender) {
    this.circuitBreaker = circuitBreaker;
    this.inner = inner;
  }

  async send(events: PixelEvent[], options?: SendOptions): Promise<SendResult> {
    if (!this.circuitBreaker.canExecute()) {
      throw new Error('[CircuitBreakerSender] Circuit is open — send blocked');
    }

    try {
      const result = await this.inner.send(events, options);
      if (result.ack) {
        this.circuitBreaker.recordSuccess();
      } else {
        this.circuitBreaker.recordFailure();
      }
      return result;
    } catch (error) {
      if (shouldTripCircuitBreaker(error)) {
        this.circuitBreaker.recordFailure();
      }
      throw error;
    }
  }

  getCircuitBreaker(): CircuitBreaker {
    return this.circuitBreaker;
  }
}
